import { render, staticRenderFns } from "./angleDouble.vue?vue&type=template&id=17c86bd2&"
import script from "./angleDouble.vue?vue&type=script&lang=js&"
export * from "./angleDouble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports